import { MainScope } from 'mormaii-web-presentation/main'
import type { ViewFactory } from 'wdc-cube-solid'

import { MainView } from './v-main'

export function registerViews(rv: typeof ViewFactory.register) {
    rv(MainScope, MainView)
}

export { MainView }
